"use strict";
// copied from @vwa/components-configure
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EfficiencyClassIndicator = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const React = __importStar(require("react"));
const efficiency_class_arrow_path_1 = require("./efficiency-class-arrow-path");
const StyledSvg = components_core_1.styled.svg `
  vertical-align: middle;
`;
const EfficiencyClassIndicator = ({ id, bestEfficiencyClass, efficiencyClass, graphAriaTitle, graphAriaDescription }) => {
    const pathWidth = (0, efficiency_class_arrow_path_1.getBaselinePathWidth)(bestEfficiencyClass);
    // Magic numbers: unique use here to declare the width of the efficiency arrow svg
    const svgWidth = pathWidth + efficiency_class_arrow_path_1.arrowTipWidth; // Result of: pathWidth + the arrowTipWidth as declared in efficiency-class-arrow-path
    const descriptionId = id ? `${id}-desc` : undefined;
    // use the efficiencyClass as a default title (relevant for VoiceOver) if no explicit ariaTitle is set
    const ariaTitle = id && graphAriaTitle ? graphAriaTitle : efficiencyClass;
    return (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", width: svgWidth, height: efficiency_class_arrow_path_1.arrowPathHeight, viewBox: `0 0 ${svgWidth} ${efficiency_class_arrow_path_1.arrowPathHeight}`, role: "img", "aria-describedby": graphAriaDescription && descriptionId ? descriptionId : undefined },
        React.createElement("title", null, ariaTitle),
        graphAriaDescription && descriptionId && (React.createElement("desc", { id: descriptionId }, graphAriaDescription)),
        React.createElement(efficiency_class_arrow_path_1.EfficiencyClassArrowPath, { efficiencyClass: efficiencyClass, bestEfficiencyClass: bestEfficiencyClass, width: pathWidth })));
};
exports.EfficiencyClassIndicator = EfficiencyClassIndicator;
exports.EfficiencyClassIndicator.displayName = 'EfficiencyClassIndicator';
